import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    background-color: white;\n    box-sizing: border-box;\n    flex-direction: column;\n    height: 0;\n    left: 0;\n    width: 100%;\n    overflow: auto;\n    position: absolute;\n    transition: ", "s;\n    z-index: ", ";\n\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    cursor: default;\n    display: inline-block;\n    flex-flow: row nowrap;\n    position: relative;\n\n    ", "\n    ", "\n\n    ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            height: fit-content;\n            transition: max-height ", "s ease;\n        "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n            ", ";\n            max-height: ", ";\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from 'styled-components';
import { marginAttributes, widthAttributes } from '../../system/attributes';
import { getPropsBlocker, makePropList } from '../../utils';
import { zIndexSearchSuggestionsList } from '../../tokens';
import { transitionDurationInSec } from '../../constants';
import { TextInput } from '../TextInput';
import { reset, spacing } from '../../system/mixins';
import { getComponentOverride } from '../../system/mixins/getComponentOverride';
var propertyList = makePropList(['searchQuery', 'suggestionListHeight', 'icon', 'isHighlighted']);

var searchSuggestionsContainerStyle = function searchSuggestionsContainerStyle(_ref) {
  var searchQuery = _ref.searchQuery,
      suggestionListHeight = _ref.suggestionListHeight,
      Search = _ref.theme.componentOverrides.Search;
  var result = Search.SearchSuggestionsContainer.base;

  if (suggestionListHeight) {
    result = css(_templateObject(), result, spacing(Number(suggestionListHeight)));
  }

  if (searchQuery && searchQuery.length) {
    result = css(_templateObject2(), result, transitionDurationInSec);
  }

  return result;
};

var searchTextInputStyle = function searchTextInputStyle(_ref2) {
  var Search = _ref2.theme.componentOverrides.Search;
  return Search.TextInput.base;
};

export var SearchRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject3(), reset, marginAttributes, widthAttributes, getComponentOverride('Search'));
export var SearchSuggestionsContainer = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject4(), transitionDurationInSec, zIndexSearchSuggestionsList, searchSuggestionsContainerStyle);
export var SearchSuggestionsListContainer = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject5());
export var SearchTextInput = styled(TextInput).withConfig(getPropsBlocker(propertyList, false))(_templateObject6(), searchTextInputStyle);